import { graphql } from '@/graphql-setup'

export const PATCH_TACHOGRAPH_INFRINGEMENT = graphql(`
  mutation PatchTachographInfringement(
    $id: ID!
    $solution: String
    $leadersComment: String
    $attachmentsAdd: [TachographInfringementAttachmentInput!]
    $attachmentsRemove: [ID!]
  ) {
    patchTachographInfringement(
      id: $id
      solution: $solution
      leadersComment: $leadersComment
      attachmentsAdd: $attachmentsAdd
      attachmentsRemove: $attachmentsRemove
    ) {
      tachographInfringement {
        id
        solution
        leadersComment
      }
    }
  }
`)

export const PATCH_TACHOGRAPH_INFRINGEMENT_WRONGLY_GENERATED = graphql(`
  mutation PatchTachographInfringementWronglyGenerated(
    $id: ID!
    $wronglyGenerated: Boolean!
    $explanation: String
  ) {
    patchTachographInfringementWronglyGenerated(
      id: $id
      wronglyGenerated: $wronglyGenerated
      explanation: $explanation
    ) {
      tachographInfringement {
        id
        wronglyGenerated
        wronglyGeneratedExplanation
      }
    }
  }
`)

export const PATCH_COMPANY_TACHOGRAPH_INFRINGEMENT_SETTINGS = graphql(`
  mutation PatchCompanyTachographInfringementSettings(
    $generationEnabled: Boolean
    $countryStartEnabled: Boolean
    $countryStopEnabled: Boolean
    $manualEntryEnabled: Boolean
    $manualEntryVehicleChangeEnabled: Boolean
    $borderCrossingEnabled: Boolean
    $minManualEntryGapMinutes: Int
    $maxManualEntryGapMinutes: Int
  ) {
    patchCompanyTachographInfringementSettings(
      generationEnabled: $generationEnabled
      countryStartEnabled: $countryStartEnabled
      countryStopEnabled: $countryStopEnabled
      manualEntryEnabled: $manualEntryEnabled
      manualEntryVehicleChangeEnabled: $manualEntryVehicleChangeEnabled
      borderCrossingEnabled: $borderCrossingEnabled
      minManualEntryGapMinutes: $minManualEntryGapMinutes
      maxManualEntryGapMinutes: $maxManualEntryGapMinutes
    ) {
      settings {
        id
        generationEnabled
        countryStartEnabled
        countryStopEnabled
        manualEntryEnabled
        manualEntryVehicleChangeEnabled
        borderCrossingEnabled
        minManualEntryGapMinutes
        maxManualEntryGapMinutes
      }
    }
  }
`)

export const PATCH_TACHOGRAPH_INFRINGEMENT_CLOSED = graphql(`
  mutation PatchTachographInfringementClosed($id: ID!, $closed: Boolean!) {
    patchTachographInfringementClosed(id: $id, closed: $closed) {
      tachographInfringement {
        id
        closedAt
      }
    }
  }
`)

export const PATCH_TACHOGRAPH_INFRINGEMENT_ARCHIVED = graphql(`
  mutation PatchTachographInfringementArchived(
    $id: ID!
    $archived: Boolean!
    $archivedBasis: String
  ) {
    patchTachographInfringementArchived(
      id: $id
      archived: $archived
      archivedBasis: $archivedBasis
    ) {
      tachographInfringement {
        id
        archivedAt
        archivedBasis
      }
    }
  }
`)
